<template>

	<div class="settings modal">

		<div class="modal-wrap">

			<div class="modal-inner">

				<h2 class="modal-title">Gift Some Credits<span class="close" @click="close">X</span></h2>

				<div class="modal-inner-scroll">

					<form class="form normal" @submit.prevent="saveSettings">

						<FormInput type="number" :noMarginBottom="true" label="Credits (Use - to remove eg. -100 to remove 100)" v-model="credits" placeholder="0" />

						<span class="large-button" @click="addCredits">Save</span>

					</form>

				</div>

			</div>

		</div>

	</div>

</template>

<script>
import { mapMutations } from 'vuex'
import FormInput from './Form/Input.vue'
export default {
	name: 'AddCredits',
	components: {
		FormInput
	},
	props: {

	},
	data() {

		return {
			credits: ''
		}

	},
	computed: { 
		buttonText () {

			return 'Save';

		}

    },
	mounted() {

	

	},

	methods: {

		...mapMutations('general',['updateLoadingText']),

		saveSettings () {


		},

		close() {

			this.$emit('close');

		},

	    addCredits() {

	    	this.$emit('save',this.credits);

	    }

	}
}
</script>

<style lang="less" scoped>
.modal {
	&.settings {
		.modal-inner {
			max-width: 550px;
		}
	}
}
</style>